import { render, staticRenderFns } from "./titleHeader.vue?vue&type=template&id=07a2e068&scoped=true"
import script from "./titleHeader.vue?vue&type=script&lang=js"
export * from "./titleHeader.vue?vue&type=script&lang=js"
import style0 from "./titleHeader.vue?vue&type=style&index=0&id=07a2e068&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a2e068",
  null
  
)

export default component.exports